import { TOOLBAR_CLASS_NAME, CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME } from '../../constants/toolbar';
import FingoMuiToolbar, { credentialsUpdateBottomBarClassName } from '../../fingo/components/MuiToolbar';
import NAVBAR_HEIGHT from '../constants/navbar';

const toolbarclassName = ({ theme }) => ({
  minHeight: NAVBAR_HEIGHT,
  backgroundColor: theme.palette.primary.main,
  paddingLeft: 41,
  paddingRight: 52,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 20,
    paddingRight: 20,
  },
});

const MuiToolbar = {
  navbarHeight: NAVBAR_HEIGHT,
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiToolbar.styleOverrides.root({ theme }),
      [`&.${TOOLBAR_CLASS_NAME}`]: toolbarclassName({ theme }),
      [`&.${CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME}`]: credentialsUpdateBottomBarClassName({ theme, 
        backgroundColor: theme.palette.secondary.A400 }),
    }),
  },
};

export default MuiToolbar;
